// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/licence-privileges.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/licence-privileges/licence-privileges.js';

mount([g0]);
